<template>
  <div class="con">
    <div class="main">
      <div class="left">
        <div class="one">
          <ul>
            <li>
              <a href>至锐信息</a>
            </li>
            <li>
              <a href="/pro.html" target="_self">所有商品</a>
            </li>
            <li>
              <a href="/tech.html" target="_self">3D云设计</a>
            </li>
            <li>
              <a href="/design.html" target="_self">设计方案</a>
            </li>
            <li>
              <a href="/collect.html" target="_self">我的收藏</a>
            </li>
          </ul>
          <ul>
            <li>
              <a href="/coop.html">关于我们</a>
            </li>
            <li>
              <a href="/brand.html">品牌介绍</a>
            </li>
            <li>
              <a href="/contact.html">联系方式</a>
            </li>
            <li>
              <a href="/coop.html">加盟合作</a>
            </li>
            <li>
              <a @click="showAll">旗下品牌</a>
            </li>
          </ul>
        </div>
        <div class="allImg">
          <!-- <div class="l1">
            <p>Links</p>
            <p>富邦旗下品牌</p>
          </div>-->
          <div class="l11">
            <a class="l2" href="https://www.fb1952.com/" target="_blank">
              <img class="img1" src="../assets/fb/fb.svg" style="width: 130px;height: 34px;" alt />
              <img class="img2" src="../assets/fb/fb_.svg" style="width: 130px;height: 34px;" alt />
            </a>
            <a class="l2" href="http://www.fhplaza.com/" target="_blank">
              <img class="img1" src="../assets/fb/2.png" alt />
              <img class="img2" src="../assets/fb/c2.png" alt />
            </a>
            <a class="l2" href="http://www.ebincasa.com/" target="_blank">
              <img class="img1" src="../assets/fb/3.png" alt />
              <img class="img2" src="../assets/fb/c3.png" alt />
            </a>
            <!-- <div class="l2" href="http://zr.sansg.com/" target="_blank">
              <img class="img1" src="../assets/foot/4.png" alt />
              <img class="img2" src="../assets/foot/44.png" alt />
            </div>-->
            <a class="l2" href="https://www.fb1952.com/products_dzjj.php?pid=1#top" target="_blank">
              <img class="img1" src="../assets/foot/5.png" alt />
              <img class="img2" src="../assets/foot/55.png" alt />
            </a>
          </div>
        </div>
        <div class="two">
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
          >Copyright©{{year}} 富邦美品家具至锐 All Rights Reserved 版权所有 浙ICP备19052612号-2</a>

        </div>
      </div>
      <div class="right">
        <p>
          <i class="iconfont icon-yduixinlangweibo"></i>
          <i class="iconfont icon-QQ"></i>
          <i class="iconfont icon-weixin-copy"></i>
        </p>
        <div>
          <img src="../assets/zr/code.png" alt />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getClass } from "../util/lang";
import "../common/jquery-1.11.3.min";
export default {
  name: "foot",
  data() {
    return {
      year:''
    };
  },
  mounted() {
    this.$nextTick(() => {
      // this.getNav('9')
      let date = new Date();
      let y = date.getFullYear();
      this.year=y
    });
  },
  methods: {
    showAll() {
      $(".allImg").slideToggle()();
    },
    goto(n, i) {
      console.log(n, i);
      if (n === 0 && i === 0) {
        const link = "/about.html";
        window.open(link, "_self");
      } else if (n === 0 && i !== 0) {
        const link = `/about.html?index=${i - 1}`;
        window.open(link, "_self");
      } else if (n === 1 && i === 0) {
        const link = "/pro.html";
        window.open(link, "_self");
      } else if (n === 1 && i !== 0) {
        const link = `/pro.html?id=${i - 1}`;
        window.open(link, "_self");
      } else if (n === 2 && i === 0) {
        const link = "/news.html";
        window.open(link, "_self");
      } else if (n === 2 && i !== 0) {
        const link = `/news.html?index=${i - 1}`;
        window.open(link, "_self");
      } else if (n === 3 && i === 0) {
        const link = "/design.html";
        window.open(link, "_self");
      } else if (n === 3 && i !== 0) {
        const link = `/job.html?index=${i - 1}`;
        window.open(link, "_self");
      } else if (n === 4 && i === 0) {
        const link = "/tech.html";
        window.open(link, "_self");
      } else if (n === 4 && i !== 0) {
        const link = `/tech.html?index=${i - 1}`;
        window.open(link, "_self");
      } else if (n === 5 && i === 0) {
        const link = "/contact.html";
        window.open(link, "_self");
      } else {
        const link = `/contact.html?index=${i - 1}`;
        window.open(link, "_self");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.con {
  width: 100%;
  background-color: #ffffff;
  padding: 20px 0;
  .allImg {
    width: 80%;
    display: none;
    margin: 40px 0;
    // .l1{
    //     display: none;
    // }
    .l11 {
      width: 90%;
      margin: 30px auto;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .l2 {
        position: relative;
        cursor: pointer;
        .img1 {
          opacity: 1;
          transition: all 1s;
        }
        .img2 {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          opacity: 0;
          transition: all 1s;
          transform: rotateX(180deg);
        }
      }
      .l2:hover {
        .img1 {
          opacity: 0;
          transform: rotateX(180deg);
        }
        .img2 {
          opacity: 1;
          transform: rotateX(0);
        }
      }
      .l2:nth-child(1) {
        margin-left: 0;
      }
      .l2 {
        margin-left: 5%;
      }
    }
  }
  .main {
    width: 80%;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .left {
      width: 80%;
      position: relative;
      .one {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        ul {
          list-style: none;
          display: flex;
          flex-direction: row;
          li {
            color: #333137;
            font-family: "SourceHanSerifCN-Medium";
            // width:87px;
            height: 64px;
            position: relative;
            a {
              -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
              font-family: "SourceHanSerifCN-Medium";
              list-style: none;
              margin: 0;
              border: 0;
              outline: none;
              height: 67px;
              cursor: pointer;
              transition: 0.3s;
              text-decoration: none;
              position: relative;
              display: block;
              padding: 0 10px;
              font-size: 14px;
              line-height: 90px;
            }
            &::before {
              content: "";
              width: 100%;
              height: 100%;
              background: rgba(51, 49, 55, 1);
              position: absolute;
              left: 0;
              bottom: 0;
              transform-origin: 100%;
              -webkit-transform-origin: 100%;
              -webkit-transition: -webkit-transform 0.4s
                cubic-bezier(0.4, 0, 0.2, 1);
              transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
              -webkit-transform: scaleX(0);
              visibility: hidden\9;
            }
            &:hover::before {
              transform: scaleX(1);
              -webkit-transform: scaleX(1);
              -moz-transform: scaleX(1);
              transform-origin: 0;
              -webkit-transform-origin: 0;
              visibility: visible\9;
            }
            &:hover {
              a {
                color: white;
              }
            }
          }
          li:nth-child(1) {
            a {
              color: white;
            }
            &::before {
              transform: scaleX(1);
              -webkit-transform: scaleX(1);
              -moz-transform: scaleX(1);
              transform-origin: 0;
              -webkit-transform-origin: 0;
              visibility: visible\9;
            }
          }
        }
      }
      .two {
        position: absolute;
        left: 0;
        bottom: -5px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        a {
          font-family: "hy";
          color: #7c7c7c;
          font-size: 9px;
        }
      }
    }
    .right {
      width: 15%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      p {
        display: flex;
        flex-direction: row;
        justify-content: center;
        i {
          font-size: 28px;
          color: #333137;
          cursor: pointer;
          transition: all 600ms;
          margin-left: 5px;
          &:hover {
            color: black;
          }
        }
      }
      div {
        text-align: center;
        margin-top: 20px;
        img {
          margin-left: 10px;
        }
      }
    }
  }
  @media screen and (max-width: 1000px) {
    .main {
      flex-direction: column;
      align-items: center;
      .left {
        width: 100%;
        .one {
          display: none;
        }
        .allImg {
          display: block;
          width: 100%;
          margin: 0 auto;
          //   .l1 {
          //     display: flex;
          //     flex-direction: row;
          //     justify-content: center;

          //     p:nth-child(1) {
          //       font-family: monospace;
          //       font-weight: bold;
          //       font-size: 30px;
          //       color: #131313;
          //       text-transform: uppercase;
          //     }
          //     p:nth-child(2) {
          //       color: #3b3b3b;
          //       font-family: Fira Code Medium;
          //       font-size: 18px;
          //       padding-top: 10px;
          //       margin-left: 10px;
          //     }
          //   }
          .l11 {
            flex-direction: column;
            align-items: center;
            .l2 {
              margin-bottom: 20px;
            }
          }
        }
        .two {
          text-align: center;
          position: static;
          margin-bottom: 20px;
          line-height: 30px;
        }
      }
      .right {
        width: 100%;
      }
    }
  }
}
</style>
